import { TimeHelper } from '@/helpers/TimeHelper';

class SensorOrchardModel {
  id;
  deployedOn;
  name;
  sensorName;

  constructor(data) {
    this.populate(data || {});
  }

  get dateDeployed() {
    return TimeHelper.formatDate(this.deployedOn);
  }

  populate(data) {
    this.id = data.id || null;
    this.deployedOn = data.deployedOn || null;
    this.name = data.name || null;
    this.sensorName = data.sensorName;
  }

  /**
   * @TODO - Remove the eslint rule disabler.
   */
  // eslint-disable-next-line no-unused-vars
  toDetailsUpdateJson(originalData) {
    let output = {};
    // if(this.name != originalData.name) output.name = this.name
    return output; // TODO first check if object is empty
  }
}

export { SensorOrchardModel };
